<script setup>
import { router } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import DeleteTeamForm from '@/Pages/Teams/Partials/DeleteTeamForm.vue';
import JetSectionBorder from '@/Jetstream/SectionBorder.vue';
import TeamMemberManager from '@/Pages/Teams/Partials/TeamMemberManager.vue';
import UpdateTeamNameForm from '@/Pages/Teams/Partials/UpdateTeamNameForm.vue';
import TeamCustomQuestions from '@/Pages/Teams/Partials/TeamCustomQuestions.vue';
import ToggleCarbonSavings from '@/Pages/Teams/Partials/ToggleCarbonSavings.vue';
import DashboardSidebar from '@/Jetstream/DashboardSidebar.vue';

// includes we need to front end locale magic
import { useI18n } from 'vue-i18n';
// Get locale as set in cookie
let { locale } = useI18n({ useScope: 'global' });

// defineProps({
//     team: Object,
//     availableRoles: Array,
//     permissions: Object,
//     loggedInUserId: Number,
//     loggedInUserRole: Object,
//     teamAnswers: Array
// });

const props = defineProps({
    team: Object,
    availableRoles: Array,
    permissions: Object,
    loggedInUserId: Number,
    teamAnswers: Array,
    currentTeamToolkits: Array,
    loggedInUserRole: Object,
    teamAnswers: Array,
    teamDeletionData: Array
});

const loggedInUserRole = props.loggedInUserRole.role;
//console.log(loggedInUserRole);

const programme = router.page.props.ziggy.programme;

let team_custom_name = programme.team_custom_name;
if (team_custom_name) {
    if(team_custom_name.constructor.name != 'Object') {
        team_custom_name = JSON.parse(team_custom_name);
    }
}

let default_team_name;

if (locale.value == 'cy') {
    default_team_name = 'tîm';

} else  {
    default_team_name = 'team';
}

let team_name = default_team_name;

if (team_custom_name) {
    team_name =  team_custom_name[locale.value] == null ? default_team_name : team_custom_name[locale.value];
}

const currentTeamToolkits = Array.isArray(props.currentTeamToolkits)
            ? props.currentTeamToolkits
            : Object.keys(props.currentTeamToolkits).map(key => props.currentTeamToolkits[key]);

const canDisplayCarbon = () => { //if any toolkits have carbon enabled, then we can enable if for the team
    let canDisplay = false;
    if (currentTeamToolkits) {
        for (const el of currentTeamToolkits) {
            if (el.toolkit.display_carbon_savings) {
                canDisplay = true;
                break;
            }
        };
    }
    return canDisplay;
}

</script>

<template>
    <AppLayout title="Team Settings">

        <div class="container flex flex-col justify-between w-full mx-auto lg:flex-row">

            <div id="sos-programme-dashboard-sidebar" class="order-2 w-full min-h-screen p-10 lg:order-1 lg:w-1/4 xl:w-1/5">
                <DashboardSidebar />
            </div>


            <div class="order-1 w-full lg:order-2 lg:w-3/4 xl:w-4/5 sos-programme-dashboard-content">
                <div class="overflow-hidden">
                    <h1 class="pt-5 pl-10 dashboard-title">
                        <span style="text-transform: capitalize;">{{ $t('teams.settings.title', { team_name: team_name }) }}</span>
                    </h1>
                    <div class="p-10 pt-5 lg:pr-0">
                        <UpdateTeamNameForm :team="team" :permissions="permissions" />
                        <TeamCustomQuestions
                            :team="team"
                            :teamAnswers="teamAnswers"
                            :permissions="permissions"
                        />
                        <TeamMemberManager
                            class="mt-10 sm:mt-0"
                            :team="team"
                            :available-roles="availableRoles"
                            :user-permissions="permissions"
                            :loggedInUserId="loggedInUserId"
                            :loggedInUserRole="loggedInUserRole"
                        />

                        <template v-if="canDisplayCarbon()">
                            <JetSectionBorder />
                            <ToggleCarbonSavings
                                class="mt-10 sm:mt-0"
                                :team="team"
                                :permissions="permissions"
                            />
                        </template>

                        <template v-if="(loggedInUserRole == 'admin' || loggedInUserRole == 'member') && ! team.personal_team">
                            <JetSectionBorder />
                            <DeleteTeamForm class="mt-10 sm:mt-0"
                            :team="team"
                            :available-roles="availableRoles"
                            :loggedInUserId="loggedInUserId"
                            :loggedInUserRole="loggedInUserRole"
                            :teamDeletionData="teamDeletionData"
                            />
                        </template>
                    </div>
                </div>
            </div>
        </div>

    </AppLayout>
</template>
